import { getToken } from './cookieUtils';

// Centralized API utility function
export const apiCall = async (url, options = {}) => {
  const token = getToken();
  
  // Default headers
  const defaultHeaders = {
    'Content-Type': 'application/json',
  };

  // Add Authorization header if token exists
  if (token) {
    defaultHeaders.Authorization = `Bearer ${token}`;
  }

  // Merge default headers with provided headers
  const headers = {
    ...defaultHeaders,
    ...options.headers,
  };

  // Create final config
  const config = {
    ...options,
    headers,
  };

  try {
    const response = await fetch(url, config);
    return response;
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
};

// Specific API methods for convenience
export const apiGet = (url, options = {}) => {
  return apiCall(url, {
    method: 'GET',
    ...options,
  });
};

export const apiPost = (url, data = {}, options = {}) => {
  return apiCall(url, {
    method: 'POST',
    body: JSON.stringify(data),
    ...options,
  });
};

export const apiPut = (url, data = {}, options = {}) => {
  return apiCall(url, {
    method: 'PUT',
    body: JSON.stringify(data),
    ...options,
  });
};

export const apiDelete = (url, options = {}) => {
  return apiCall(url, {
    method: 'DELETE',
    ...options,
  });
};

// Helper function to get JSON response
export const getJsonResponse = async (response) => {
  return await response.json().catch(() => ({}));
};
